export const HELM_LINK = 'https://helm.sh';
export const KUBECTL_LINK = 'https://kubernetes.io/docs/tasks/tools/';
// TODO: Update links when available (for GA)
export const LEARN_MORE_LINK = 'this is a placeholder for the learn more link';
export const KB_LINK = 'this is a placeholder for the KB link';

export const DOWNLOAD_HELM_CHART_SCRIPT = `helm repo add bitdefender https://download.bitdefender.com/business/k8s && helm repo update`;

export const ADD_HELM_CHART_TO_CLUSTER_SCRIPT = `helm install --create-namespace --namespace bitdefender-kspm bitdefender-kspm \\
    --set "gravityzone.server=<GZ_SERVER>" \\
    --set "gravityzone.companyid=<COMPANY_ID>" \\
    --set "gravityzone.csrtoken=<CSR_TOKEN>" \\
    --set "gravityzone.clustername=$(kubectl config view --minify -o jsonpath='{.clusters[].name}')" \\
    --set "gravityzone.contextname=$(kubectl config current-context)" \\
    --set "gravityzone.accesskey=<ACCESS_KEY>" \\
    --set "cnapp.server=<CNAPP_SERVER>" \\
    bitdefender/bitdefender-kspm`;
